import { postRequest } from "../config/axiosConfig";
import { GetOverviewDetailsRequest, GetOverviewDetailsResponse } from "../interfaces/overview.interfaces";

class OverViewService {
    baseUrl: string;
    token: string;
    nonce: string;

    constructor(token: string, nonce: string) {
        this.baseUrl = "overview";
        this.token = token;
        this.nonce = nonce;
    }

    private get headers() {
        return {
            "Content-Type": "application/json",
            Token: this.token,
            Nonce: this.nonce,
        };
    }

    async getDetails(body: GetOverviewDetailsRequest): Promise<{ status: number; data: GetOverviewDetailsResponse }> {
        const { status, data } = await postRequest(`${this.baseUrl}/getDetails/`, body, this.headers);
        return {
            status: status,
            data: data,
        };
    }
}

export default OverViewService;
